import React from "react";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, options, className = "", ...props }: SelectProps) {
  return (
    <label className="block">
      {label && (
        <span
          className="text-xs font-medium mb-1.5 block"
          style={{ color: "var(--c-text-secondary)" }}
        >
          {label}
        </span>
      )}
      <select
        className={`w-full rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none ${className}`}
        style={{
          backgroundColor: "var(--c-input-bg)",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "var(--c-border)",
          color: "var(--c-text)",
        }}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}
